/**
 * @file Centralized configuration for authCore module
 * @description Contains all configuration constants used across the auth system
 */

export const STORAGE_KEYS = {
  AUTH_DATA: '@Livia',
  KEEP_LOGGED: '@Livia/KEEP_LOGGED',
} as const;

export const URLS = {
  BFF_URL: process.env.BFF_URL || '',
  LOGIN_EXPIRED: '/entrar?origin=sessao-expirada',
} as const;
